/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Megamenu
(function(){

    // convert Royal Blue to royal-blue
    function shopifyHandleize(str) {
    return str
        .toLowerCase()
        .normalize("NFD")                // split accents from letters
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/[^a-z0-9]+/g, "-")     // replace non-alphanumeric with dashes
        .replace(/^-+|-+$/g, "");        // trim leading/trailing dashes
    }    

    // merge 1st & 2nd subnav
    var $megamenuInners = document.querySelectorAll('.MegaMenu .MegaMenu__Inner');
    $megamenuInners.forEach(function($megamenuInner) {
        var $cols = $megamenuInner.querySelectorAll('.MegaMenu__Item');
        if ($cols.length >= 3) {
            console.log($cols[0]);
            console.log($cols[1]);
    
            let col2Title = $cols[1].querySelector('.MegaMenu__Title');
            let col2List = $cols[1].querySelector('.Linklist');
    
            if (col2Title && col2List) {
                $cols[0].appendChild(col2Title);
                $cols[0].appendChild(col2List);
                
                $megamenuInner.removeChild($cols[1]);
            }
        }    
    });

    var mobileMegamenuTexts = ['Women','Men'];
    // to store desktop megamenu based on title, to match it with mobile one, value will be { 'Men' : obj, 'Women': obj }
    var desktopMegamenuObjs = {};

    // color swatches & sale
    var headerElement = document.querySelector('.Header');
    if (headerElement) {
        let colorSwatches = headerElement.getAttribute('data-color-swatches');
        let assetBase = headerElement.getAttribute('data-asset-base');
        let linkLabels = headerElement.getAttribute('data-link-labels');
        let data = JSON.parse(colorSwatches);      
        let labelsData = JSON.parse(linkLabels);

        // cleanup
        // data.forEach(function(color) {
        //     color = color.replace(/\n/g, '');
        // });        
        data = data.map((color)=> color.replace(/\n/g, '') );
        let colors = {};
        data.forEach(function(color) {
            var colorData = color.split(':');
            colors[colorData[0]] = colorData[1];
        });

        labelsData = labelsData.map((color)=> color.replace(/\n/g, '') );
        let labels = {};
        labelsData.forEach(function(color) {
            var labelsData = color.split(':');
            labels[labelsData[0]] = labelsData[1];
        });

        // console.log('DEBUG: color swatches', data);
        // console.log('DEBUG: color swatches obj', colors);

        console.log('DEBUG: link labels', labels);

        let $links = document.querySelectorAll('.MegaMenu .Linklist .Link');
        // console.log('DEBUG: links', $links);
        $links.forEach(function($link) {
            let text = $link.textContent.trim();
            // console.log('DEBUG: text', text);

            // to differentiate men/women
            // get closest with class .HorizontalList__Item
            let $firstLevelParent = $link.closest('.HorizontalList__Item');
            let firstLevelParentText;
            if ($firstLevelParent) {
                // check its direct > a, and get the raw text
                let $firstLevelParentLink = $firstLevelParent.querySelector(':scope > a');
                if ($firstLevelParentLink) {
                    // firstLevelParentText = $firstLevelParentLink.textContent.trim();
                    firstLevelParentText = Array.from($firstLevelParentLink.childNodes)
                                            .filter(node => node.nodeType === Node.TEXT_NODE)
                                            .map(node => node.textContent.trim())
                                            .join('');
                    // console.log('DEBUG: first level parent text', firstLevelParentText);

                    if (mobileMegamenuTexts.includes(firstLevelParentText)) {
                        desktopMegamenuObjs[firstLevelParentText] = $firstLevelParent;
                    }
                    
                }
            }


            for (var propertyName in colors) {
                if (colors.hasOwnProperty(propertyName)) {
                    // console.log(propertyName + ': ' + colors[propertyName]);

                    if (text === propertyName) {
                        // add color icon
                        let spanElement = document.createElement('span');
                        spanElement.className = 'Link__Color';
                        spanElement.style.backgroundColor = colors[propertyName];
                        spanElement.setAttribute('data-color-name', propertyName);

                        // let parentHandleName = shopifyHandleize(firstLevelParentText);
                        // let colorHandleName = shopifyHandleize(propertyName);
                        // spanElement.style.backgroundImage = 'url(' + assetBase + 'thumb-color-'+parentHandleName+'-'+colorHandleName + '.jpg)';

                        // spanElement.innerHTML = propertyName;

                        $link.appendChild(spanElement);
                        $link.classList.add('Link--color');    
                        
                        // add class Linklist__Item--color to its parent
                        let $parent = $link.closest('.Linklist__Item');
                        if ($parent) {
                            $parent.classList.add('Linklist__Item--color');
                        }

                        break;
                    }
                }
            }            

            for (var labelName in labels) {
                if (labels.hasOwnProperty(labelName)) {
                    // console.log(labelName + ': ' + labels[labelName]);

                    if (text === labelName) {
                        // add label
                        let spanElement = document.createElement('span');
                        spanElement.className = 'Link__Label';
                        spanElement.textContent = labels[labelName];
                        $link.appendChild(spanElement);
                        $link.classList.add('Link--label');                                    
                        break;   
                    }
                }
            }

            if (text.indexOf('Sale') > -1) {
                $link.classList.add('Link--sale');
            }

        });


        // sidebar menu
        var sidebarMenuElement = document.querySelector('.SidebarMenu');
        if (sidebarMenuElement) {
            let $mobileLinks = document.querySelectorAll('.SidebarMenu__Nav .Link');
            $mobileLinks.forEach(function($mobileLink) {
                let text = $mobileLink.textContent.trim();
                // console.log('DEBUG: mobile link text', text);

                // to differentiate men/women
                // get closest with class .HorizontalList__Item
                let $firstLevelParent = $mobileLink.closest('.SidebarMenu__Nav > .Collapsible');
                let firstLevelParentText;
                if ($firstLevelParent) {
                    // check its direct > button, and get the raw text
                    let $firstLevelParentLink = $firstLevelParent.querySelector(':scope > .Collapsible__Button');
                    if ($firstLevelParentLink) {
                        firstLevelParentText = $firstLevelParentLink.textContent.trim();
                        // firstLevelParentText = Array.from($firstLevelParentLink.childNodes)
                        //                         .filter(node => node.nodeType === Node.TEXT_NODE)
                        //                         .map(node => node.textContent.trim())
                        //                         .join('');
                        // console.log('DEBUG: first level parent text mobile', firstLevelParentText);                        
                    }
                }


                // sale link
                if (text.indexOf('Sale') > -1) {
                    $mobileLink.classList.add('Link--sale');
                }

                for (var propertyName in colors) {
                    if (colors.hasOwnProperty(propertyName)) {
                        // console.log(propertyName + ': ' + colors[propertyName]);

                        if (text === propertyName) {
                            // add color icon
                            let spanElement = document.createElement('span');
                            spanElement.className = 'Link__Color';
                            spanElement.style.backgroundColor = colors[propertyName];
                            spanElement.setAttribute('data-color-name', propertyName);


                            // let colorHandleName = shopifyHandleize(propertyName);
                            // let parentHandleName = shopifyHandleize(firstLevelParentText);
                            // spanElement.style.backgroundImage = 'url(' + assetBase + 'thumb-color-'+ parentHandleName + '-' +colorHandleName + '.jpg)';

                            // spanElement.innerHTML = propertyName;

                            $mobileLink.appendChild(spanElement);
                            $mobileLink.classList.add('Link--color');    
                            
                            // add class Linklist__Item--color to its parent
                            let $parent = $mobileLink.closest('.Linklist__Item');
                            if ($parent) {
                                $parent.classList.add('Linklist__Item--color');
                            }
                            
                            let $collapsibleParent = $mobileLink.closest('.Collapsible');
                            if ($collapsibleParent) {
                                $collapsibleParent.classList.add('Collapsible--color');
                            }

                            break;
                        }
                    }
                }            
                
            });

            // mobile mega menu
            let $firstLevelButton = document.querySelectorAll('.SidebarMenu__Nav > .Collapsible > .Collapsible__Button');
            $firstLevelButton.forEach(function($button) {
                let text = $button.textContent.trim();
                if (mobileMegamenuTexts.includes(text)) {
                    // $button.classList.add('Collapsible__Button--megamenu');
                    console.log('DEBUG: mobile megamenu text', text);

                    // get closest parent with class Collapsible, and add class Collapsible--megamenu
                    let $collapsible = $button.closest('.Collapsible');
                    if ($collapsible) {
                        $collapsible.classList.add('Collapsible--megamenu');

                            // let $backButton = document.createElement('button');
                            // $backButton.className = 'Collapsible__BackButton';
                            // $backButton.textContent = 'Back';
                            // $collapsible.append($backButton);

                            // // clicking it is similar to clicking button
                            // $backButton.addEventListener('click', function() {
                            //     $button.click();
                            // });

                    }

                    let $collapsibleInner = $button.nextElementSibling;
                    if ($collapsibleInner && $collapsibleInner.classList.contains('Collapsible__Inner')) {
                        // $collapsibleInner.classList.add('Collapsible__Inner--megamenu');
                        let collapsibleContent = $collapsibleInner.querySelector('.Collapsible__Content');
                        if (collapsibleContent) {
                            // append back button as first child under collapsibleContent
                            let $backButton = document.createElement('button');
                            $backButton.className = 'Collapsible__BackButton';
                            $backButton.textContent = 'Back';
                            collapsibleContent.prepend($backButton);

                            // clicking it is similar to clicking button
                            $backButton.addEventListener('click', function() {
                                $button.click();
                            });

                            console.log('DEBUG: desktopMegamenuObjs', desktopMegamenuObjs);
                            if (desktopMegamenuObjs[text]) {
                                let obj = desktopMegamenuObjs[text];
                                // get pushImages
                                if (obj) {
                                    let pushImages = obj.querySelector('.MegaMenu .Megamenu__ItemPushImage');
                                    if (pushImages) {
                                        // duplicate pushImages and append to $collapsible
                                        let clonedPushImages = pushImages.cloneNode(true);
                                        // if ($collapsibleInner) {
                                            collapsibleContent.appendChild(clonedPushImages);
                                        // }
                                    }
                                }
                            }
                            
                        }
                    }

                }
            });
        }


      }

    // sale in 1st level menu
    let fLinks = document.querySelectorAll('.Header__MainNav .HorizontalList__Item > a');
    if (fLinks && fLinks.length) {
        fLinks.forEach(function(fLink) {
            let text = fLink.textContent.trim();
            if (text.indexOf('Sale') > -1) {
                fLink.classList.add('Link--sale');
            }
        });
    }
    // // sale in sidebar menu
    // let sLinks = document.querySelectorAll('.SidebarMenu__Nav .Link');
    // if (sLinks && sLinks.length) {
    //     sLinks.forEach(function(sLink) {
    //         let text = sLink.textContent.trim();
    //         if (text.indexOf('Sale') > -1) {
    //             sLink.classList.add('Link--sale');
    //         }
    //     });
    // }





}());


